import { useRef, useState } from "react"
import { HiverAxios } from "h-signup";


export const useGetSmToken = () => {
    const [isLoading, setLoading] = useState(false);
    const tokenRef = useRef(null);

    const fetchSmToken = (userId) => {
        setLoading(true); 
        return new Promise((res, rej) => {
            HiverAxios({
                url: `/gx/api/getSMToken`,
                type: 'post',
                params: { usersession: userId },
                callback:(response)=> {
                    if(response.status === 200){
                        tokenRef.current = response.data.token;
                        res(response.data.token);
                    }else{
                        rej(new Error("Api failed to fetch sm token "))
                    }
                },
                onfail: (err) => {
                    console.log({
                        message: err.message ||  "Failed to fetch token",
                        type: "error",
                    })
                    rej(err);
                }
            })
        }).finally(() => {
            setLoading(false);
        })
       
    }

    return {
        isLoading,
        fetchSmToken,
        smToken: tokenRef.current
    }
}